<template>
  <div class="home bg_white">

    <home-header @selectCity="selectCity"/>

    <div class="home_content">
      <home-swiper/>

      <div class="index_menu content">
        <div class="menu_item" @click="gotoExploreBySpace(1)">
          <span><img src="../assets/images/top_1_1.jpg"></span>
          <p>乡村探趣</p>
        </div>
        <div class="menu_item" @click="gotoExploreBySpace(2)">
          <span><img src="../assets/images/top_1_2.jpg"></span>
          <p>读城行动</p>
        </div>
        <div class="menu_item" @click="gotoExploreBySpace(3)">
          <span><img src="../assets/images/top_1_3.jpg"></span>
          <p>周边游学</p>
        </div>
        <div class="menu_item" @click="gotoExploreBySpace(4)">
          <span><img src="../assets/images/top_1_4.jpg"></span>
          <p>穿越中国</p>
        </div>
      </div>

      <div class="topic_content content">
        <div class="recommend_pic" @click="gotoExploreByTime(3)">
          <img src="../assets/images/top_2_1.jpg">
        </div>
        <div class="recommend_pic" @click="gotoExploreByTime(2)">
          <img src="../assets/images/top_2_2.jpg">
        </div>
        <div class="recommend_pic" @click="gotoExploreByTime(1)">
          <img src="../assets/images/top_2_3.jpg">
        </div>
        <div class="recommend_pic recommend_calendar" @click="toggleCalendar">
          <img v-if="calendarLabel" src="../assets/images/top_2_4_1.jpg">
          <img v-else src="../assets/images/top_2_4.jpg">
          <span v-if="calendarLabel">{{ calendarLabel }}</span>
        </div>
        <transition name="fade">
          <activity-calendar v-show="showCalendar" class="home_calendar" :areaid="listQuery.areaid" @select="selectDate"/>
        </transition>
      </div>

      <div class="recommend_content content">
        <pagination :data="list" @pagination="loadMore">
          <template slot-scope="scope">
            <activity-item v-for="activity in scope.data" :key="activity.id" :activity="activity"/>
          </template>
        </pagination>
      </div>
    </div>

    <my-footer/>

  </div>
</template>

<script>
import homeHeader from '@/components/home/homeHeader.vue'
import homeSwiper from '@/components/home/homeSwiper.vue'
import activityCalendar from '@/components/activity/activityCalendar.vue'
import activityItem from '@/components/activity/item.vue'
import pagination from '@/components/common/pagination.vue'
import myFooter from '@/components/myFooter.vue'
import { completeNum } from '@/utils/index'
import { getActivityList } from '@/api/activity'
import { Indicator } from 'mint-ui'

export default {
  name: 'home',
  data () {
    return {
      showCalendar: false,
      calendarLabel: '',
      loading: false,
      hasMore: false,
      list: [],
      listQuery: {
        areaid: '',
        date: '',
        page: 1,
        limit: 8
      }
    }
  },
  components: {
    homeHeader,
    homeSwiper,
    activityCalendar,
    activityItem,
    pagination,
    myFooter
  },
  mounted () {
  },
  created () {
    this.getActivityList()
  },
  methods: {
    selectCity (city) {
      this.listQuery.areaid = city.id || ''
      this.listQuery.page = 1
      this.getActivityList()
    },
    toggleCalendar () {
      this.showCalendar = !this.showCalendar
    },
    selectDate (value) {
      this.showCalendar = false
      let year = value[0]
      let month = completeNum(value[1], 2)
      let day = completeNum(value[2], 2)
      this.calendarLabel = month + '/' + day
      this.listQuery.date = year + '-' + month + '-' + day
      this.listQuery.page = 1
      this.getActivityList()
    },
    async getActivityList () {
      this.loading = true
      let response = await getActivityList(this.listQuery)

      if (this.listQuery.page === 1) {
        this.list = response.data.results
      } else {
        this.list = this.list.concat(response.data.results)
      }

      this.hasMore = this.list.length < response.data.count
      this.loading = false
    },
    async loadMore () {
      if (this.loading || !this.hasMore) return false

      Indicator.open({ spinnerType: 'fading-circle' })
      this.listQuery.page += 1
      await this.getActivityList()
      Indicator.close()
    },
    gotoExploreBySpace (type) {
      this.$router.push('/explore?space=' + type)
    },
    gotoExploreByTime (type) {
      this.$router.push('/explore?time=' + type)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";

  .index_menu {
    font-size: rem(20);
    width: 100%;
    padding-top: rem(30);
    display: flex;
    justify-content: space-around;
    .menu_item {
      text-align: center;
      width: 25%;
      color: #ff9500;
      span {
        display: block;
        width: 100%;
        img {
          max-width: 96%;
        }
      }
      p {
        width: 100%;
        height: rem(40);
        line-height: rem(40);
      }
    }
  }

  .topic_content {
    font-size: rem(26);
    margin-top: rem(20);
    display: flex;
    justify-content: space-around;
    position: relative;
    height: rem(80);
    .recommend_pic {
      position: relative;
      width: 25%;
      img {
        width: 95%;
        border-radius: 5px;
      }
      span {
        color: #000;
        position: absolute;
        color: #fff;
        left: 0;
        right: 5%;
        text-align: center;
        height: rem(30);
        top: 50%;
        margin-top: rem(-19);
      }
    }
    .home_calendar {
      position: absolute;
      width: 100%;
      left: 0;
      top: rem(90);
      z-index: 999;
    }
  }

  .recommend_content {
    margin-top: rem(10);
  }

</style>
